<template>
  <span :class="`svg svg-${type}`">

    <!-- Accounting -->
    <svg
      v-if="type === 'accounting'"
      :class="'icon-' + type"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 16"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20 0V6C18.9 6 18 6.9 18 8C18 9.1 18.9 10 20 10V16H0V10C1.11 10 2 9.1 2 8C2 6.9 1.11 6 0.01 6V0H20ZM9 13.5H11V11.5H9V13.5ZM11 9H9V7H11V9ZM9 4.5H11V2.5H9V4.5Z"/>
    </svg>
    <!-- Alert -->
    <svg 
      v-if="type === 'alert'"
      :class="'icon-' + type"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 20"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9 15V13H11V15H9ZM9 5V11H11V5H9Z"/>
    </svg>

    <!-- Arrow -->
    <svg 
      v-else-if="type === 'arrow'"
      :class="'icon-' + type"
      :width="width" 
      :height="height"
      viewBox="0 0 14 8"
    >
        <path d="M6.6692 0.485829C6.91609 0.222672 7.33391 0.222672 7.5808 0.48583L13.1739 6.44737C13.5483 6.84648 13.2653 7.5 12.7181 7.5L1.53192 7.5C0.98466 7.5 0.701676 6.84648 1.07612 6.44737L6.6692 0.485829Z"/>
    </svg>
    <svg 
      v-else-if="type === 'arrow-left'"
      :class="'icon-' + type"
      :width="width" 
      :height="height"
      viewBox="0 0 12 12"
    >
        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.69378 10.564L5.30167 11.1719L6.51747 9.95608L5.90957 9.34819L2.93537 6.37399L10.6032 6.37399L11.4629 6.37399L11.4629 4.6546L10.6032 4.6546L2.98453 4.6546L5.89952 1.83363L6.5173 1.23578L5.3216 0.00022453L4.70382 0.598074L0.262068 4.89655C0.0964676 5.05681 0.00214056 5.27684 0.000252265 5.50728C-0.00163603 5.73772 0.0890708 5.95927 0.252022 6.12222L4.69378 10.564Z" fill="#00A963"/>
    </svg>

    <svg
      v-else-if="type === 'bookable-soon'"
      :class="'icon-' + type"
      :width="width" 
      :height="height"
      viewBox="0 0 11 11"
    >
      <path d="M5.50004 0.0859375C2.52087 0.0859375 0.083374 2.52344 0.083374 5.5026C0.083374 8.48177 2.52087 10.9193 5.50004 10.9193C8.47921 10.9193 10.9167 8.48177 10.9167 5.5026C10.9167 2.52344 8.47921 0.0859375 5.50004 0.0859375ZM5.50004 9.83594C3.11129 9.83594 1.16671 7.89135 1.16671 5.5026C1.16671 3.11385 3.11129 1.16927 5.50004 1.16927C7.88879 1.16927 9.83337 3.11385 9.83337 5.5026C9.83337 7.89135 7.88879 9.83594 5.50004 9.83594ZM5.77087 2.79427H4.95837V6.04427L7.77504 7.77761L8.20837 7.07344L5.77087 5.61094V2.79427Z"/>
    </svg>

    <!-- Calendar -->
    <svg
      v-else-if="type === 'calendar'"
      :class="'icon-' + type"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 22"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17 2H20V22H0V2H3V0H5V2H15V0H17V2ZM2 20H18V7H2V20Z"/>
    </svg>

    <!-- Car -->
    <svg 
      v-else-if="type === 'car'"
      :class="'icon-' + type"
      :width="width" 
      :height="height" 
      viewBox="0 0 18 16"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2.43 0H15.58L18 7V16H15V14H3V16H0V7L2.43 0ZM2 9.5C2 10.33 2.67 11 3.5 11C4.33 11 5 10.33 5 9.5C5 8.67 4.33 8 3.5 8C2.67 8 2 8.67 2 9.5ZM14.5 11C13.67 11 13 10.33 13 9.5C13 8.67 13.67 8 14.5 8C15.33 8 16 8.67 16 9.5C16 10.33 15.33 11 14.5 11ZM3.5 1.5L2 6H16L14.5 1.5H3.5Z"/>
    </svg>

    <svg
      v-else-if="type === 'check'"
      :width="width" 
      :height="height" 
      viewBox="0 0 11 8"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.67388 6.76396C4.28759 7.13221 3.68018 7.13221 3.29388 6.76396L0.373884 4.16396C0.084299 3.93141 -0.0525485 3.55752 0.0184922 3.19297C0.0895329 2.82843 0.356758 2.53329 0.712474 2.42649C1.06819 2.31969 1.45379 2.41883 1.71388 2.68396L3.93388 4.68396L8.34388 0.343959C8.59033 0.0604626 8.97487 -0.0610067 9.33945 0.0294744C9.70403 0.119955 9.98716 0.407123 10.0725 0.772952C10.1578 1.13878 10.0308 1.52156 9.74388 1.76396L4.67388 6.76396Z"/>
    </svg>

    <!-- Chevron-small -->
    <svg 
      v-else-if="type === 'chevron-small'"
      :width="width" 
      :height="height" 
      viewBox="0 0 6 10"
    >
      <path d="M0.240479 4.97638C0.240479 5.18634 0.323486 5.367 0.484619 5.52814L4.23462 9.18536C4.36157 9.31232 4.51782 9.38068 4.70337 9.38068C5.08423 9.38068 5.38696 9.07794 5.38696 8.70197C5.38696 8.51642 5.31372 8.34064 5.177 8.20392L1.85669 4.98126L5.177 1.75372C5.30884 1.617 5.38696 1.44611 5.38696 1.25568C5.38696 0.8797 5.08423 0.576965 4.70337 0.576965C4.51782 0.576965 4.36157 0.645325 4.22974 0.772278L0.484619 4.4295C0.318604 4.6004 0.240479 4.7713 0.240479 4.97638Z"/>
    </svg>

    <!-- Chevron -->
    <svg 
      v-else-if="type === 'chevron'"
      :width="width" 
      :height="height" 
      viewBox="0 0 12 8"
    >
      <path d="M1.4865 -4.8816e-07L6.32693 4.82989L11.1674 -6.49958e-08C11.9886 0.821209 11.9886 2.15265 11.1674 2.97386L6.32693 7.8143L1.4865 2.97386C0.665288 2.15265 0.665288 0.821209 1.4865 -4.8816e-07Z"/>
    </svg>

    <!-- Chevron Roung -->
    <svg 
      v-else-if="type === 'chevron-round'"
      :width="width" 
      :height="height" 
      viewBox="0 0 7 12"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.29828 0.587626C5.61397 0.265134 6.13306 0.265134 6.44876 0.587626C6.75508 0.900546 6.75508 1.40093 6.44876 1.71385L2.25296 6L6.44876 10.2861C6.75508 10.5991 6.75508 11.0995 6.44876 11.4124C6.13306 11.7349 5.61397 11.7349 5.29828 11.4124L0.684789 6.69953C0.304253 6.3108 0.304254 5.68919 0.684789 5.30046L5.29828 0.587626Z" fill="#00A963"/>

    </svg>

    <svg 
      v-else-if="type === 'chevron-down-round'"
      :width="width" 
      :height="height" 
      viewBox="0 0 11 9"
    >
      <path d="M0.659592 0.59375L5.50003 5.42364L10.3405 0.59375C11.1617 1.41496 11.1617 2.7464 10.3405 3.56761L5.50003 8.40805L0.659592 3.56761C-0.161616 2.7464 -0.161616 1.41496 0.659592 0.59375Z"/>
    </svg>

    <svg
      v-else-if="type === 'chevron-left'"
      :width="width" 
      :height="height"
      viewBox="0 0 10 13"
    >
      <path d="M9.40918 0.959581L4.02451 6.35601L9.40918 11.7524C8.49364 12.668 7.00927 12.668 6.09373 11.7524L0.697306 6.35601L6.09373 0.959581C7.00927 0.0440452 8.49364 0.0440454 9.40918 0.959581Z"/>
    </svg>

    <svg
      v-else-if="type === 'chevron-right'"
      :width="width" 
      :height="height"
      viewBox="0 0 10 13"
    >
      <path d="M0.697386 11.7514L6.08205 6.35493L0.697387 0.958506C1.61292 0.0429707 3.0973 0.0429703 4.01284 0.958506L9.40926 6.35493L4.01284 11.7514C3.0973 12.6669 1.61292 12.6669 0.697386 11.7514Z"/>
    </svg>


     <svg 
      v-else-if="type === 'chevron-up-round'"
      :width="width" 
      :height="height" 
      viewBox="0 0 12 9"
    >
      <path d="M10.8404 8.68359L5.99997 3.8537L1.15954 8.68359C0.338329 7.86238 0.338329 6.53094 1.15954 5.70973L5.99997 0.869298L10.8404 5.70973C11.6616 6.53094 11.6616 7.86238 10.8404 8.68359Z"/>
    </svg>

    <!-- Chart -->
    <svg 
      v-else-if="type === 'chart'"
      :width="width" 
      :height="height" 
      viewBox="0 0 24 24"
    >
      <path d="M3.5 18.4898L9.5 12.4798L13.5 16.4798L22 6.91977L20.59 5.50977L13.5 13.4798L9.5 9.47977L2 16.9898L3.5 18.4898Z"/>
    </svg>

    <svg
      v-else-if="type === 'close'"
      :width="width" 
      :height="height"
      viewBox="0 0 14 14"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.1786 2.00078L12 0.822266L7.00004 5.82227L2.00004 0.822266L0.821533 2.00078L5.82153 7.00078L0.821533 12.0008L2.00004 13.1793L7.00004 8.17929L12 13.1793L13.1786 12.0008L8.17856 7.00078L13.1786 2.00078Z"/>
    </svg>

    <!-- Criterion -->
    <svg 
      v-else-if="type === 'criterion'"
      :width="width" 
      :height="height"
      viewBox="0 0 14 15"
    >
      <circle cx="7" cy="7.5" r="7" fill="#FF0B37"/>
      <path class="success" d="M4.21447 6.2688L6.19922 8.24493L10.1527 4.30005C10.8234 4.97078 10.8234 6.05826 10.1527 6.72899L6.19922 10.6825L4.21447 8.69774C3.54374 8.02701 3.54374 6.93953 4.21447 6.2688Z" fill="white"/>
      <path class="error" fill-rule="evenodd" clip-rule="evenodd" d="M7.00029 9.12825L4.62507 11.5L3 9.87375L5.37146 7.50059L3 5.13084L4.63201 3.5L5.71758 4.58479L7.00089 5.86998L9.36916 3.5L11 5.13201L9.91521 6.21758L8.62973 7.50119L11 9.87493L9.37375 11.5L7.00029 9.12825Z" fill="white"/>
    </svg>

    <svg
      v-else-if="type === 'cross'"
      :width="width" 
      :height="height"
      viewBox="0 0 8 8"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6.36405 7.77817L7.77827 6.36396L5.30338 3.88908L7.77817 1.41428L6.36396 6.98566e-05L3.88917 2.47486L1.41431 0L9.35197e-05 1.41421L2.47496 3.88908L0 6.36403L1.41421 7.77824L3.88917 5.30329L6.36405 7.77817Z"/>
    </svg>

    <svg
      v-else-if="type === 'crossgray'"
      :width="width" 
      :height="height"
      viewBox="0 0 8 8"
    >
      <path fill="#D4D5DA" fill-rule="evenodd" clip-rule="evenodd" d="M6.36405 7.77817L7.77827 6.36396L5.30338 3.88908L7.77817 1.41428L6.36396 6.98566e-05L3.88917 2.47486L1.41431 0L9.35197e-05 1.41421L2.47496 3.88908L0 6.36403L1.41421 7.77824L3.88917 5.30329L6.36405 7.77817Z"/>
    </svg>

    <!-- Drivers -->
    <svg 
      v-else-if="type === 'drivers'"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 20"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM13.61 6.34C14.68 6.34 15.54 7.2 15.54 8.27C15.54 9.34 14.68 10.2 13.61 10.2C12.54 10.2 11.68 9.34 11.68 8.27C11.67 7.2 12.54 6.34 13.61 6.34ZM9.97 7.12C9.97 5.82 8.91 4.76 7.61 4.76C6.3 4.76 5.25 5.81 5.25 7.12C5.25 8.42 6.31 9.48 7.61 9.48C8.91 9.48 9.97 8.42 9.97 7.12ZM7.61 13.89V17.64C5.21 16.89 3.31 15.04 2.47 12.68C3.52 11.56 6.14 10.99 7.61 10.99C8.14 10.99 8.81 11.07 9.51 11.21C7.87 12.08 7.61 13.23 7.61 13.89ZM9.21 17.96C9.47 17.99 9.73 18 10 18C13.39 18 16.28 15.88 17.45 12.91C16.53 12.15 14.68 11.76 13.61 11.76C12.15 11.76 9.21 12.47 9.21 13.89V17.96Z"/>
    </svg>
    <!-- Filters -->
    <svg 
      v-else-if="type === 'filters'"
      :width="width" 
      :height="height" 
      viewBox="0 0 21 18"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0616 9.24991C14.8984 9.24991 16.461 10.4238 17.0401 12.0623L18.6863 12.0622C19.4628 12.0622 20.0924 12.6918 20.0924 13.4684C20.0924 14.245 19.4628 14.8745 18.6863 14.8745L17.0396 14.8758C16.4601 16.5136 14.8979 17.6868 13.0616 17.6868C11.2254 17.6868 9.66312 16.5136 9.08366 14.8758L1.8124 14.8745C1.03581 14.8745 0.40625 14.245 0.40625 13.4684C0.40625 12.6918 1.03581 12.0622 1.8124 12.0622L9.08317 12.0623C9.66224 10.4238 11.2248 9.24991 13.0616 9.24991ZM13.0616 11.3591C11.8967 11.3591 10.9524 12.3035 10.9524 13.4684C10.9524 14.6333 11.8967 15.5776 13.0616 15.5776C14.2265 15.5776 15.1709 14.6333 15.1709 13.4684C15.1709 12.3035 14.2265 11.3591 13.0616 11.3591ZM7.43702 0.812988C9.27381 0.812988 10.8364 1.98692 11.4155 3.62542L18.6863 3.6253C19.4628 3.6253 20.0924 4.25485 20.0924 5.03145C20.0924 5.80805 19.4628 6.4376 18.6863 6.4376L11.415 6.43887C10.8355 8.07665 9.27329 9.24991 7.43702 9.24991C5.60075 9.24991 4.03851 8.07665 3.45904 6.43887L1.8124 6.4376C1.03581 6.4376 0.40625 5.80805 0.40625 5.03145C0.40625 4.25485 1.03581 3.6253 1.8124 3.6253L3.45855 3.62542C4.03762 1.98692 5.60023 0.812988 7.43702 0.812988ZM7.43702 2.92222C6.27212 2.92222 5.32779 3.86655 5.32779 5.03145C5.32779 6.19635 6.27212 7.14068 7.43702 7.14068C8.60192 7.14068 9.54625 6.19635 9.54625 5.03145C9.54625 3.86655 8.60192 2.92222 7.43702 2.92222Z" fill="#1F2B60"/>
    </svg>

    <!-- Favorites -->
    <svg 
      v-else-if="type === 'favorite'"
      :width="width" 
      :height="height" 
      viewBox="0 0 12 19"
    >
      <path d="M1.71429 2.21429V16.4307L4.78782 13.3571C5.45729 12.6877 6.54271 12.6877 7.21218 13.3571L10.2857 16.4307V2.21429H1.71429ZM1.71429 0.5H10.2857C11.2325 0.5 12 1.26751 12 2.21429V16.4307C12 17.3774 11.2325 18.145 10.2857 18.145C9.83106 18.145 9.39502 17.9643 9.07353 17.6429L6 14.5693L2.92647 17.6429C2.257 18.3123 1.17157 18.3123 0.502103 17.6429C0.180612 17.3214 0 16.8853 0 16.4307V2.21429C0 1.26751 0.767512 0.5 1.71429 0.5Z"/>
    </svg>

    <!-- Eye of tiger -->
    <svg 
      v-else-if="type === 'eye-of-tiger'"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 14"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0.5C5.45455 0.5 1.57273 3.19533 0 7C1.57273 10.8047 5.45455 13.5 10 13.5C14.5455 13.5 18.4273 10.8047 20 7C18.4273 3.19533 14.5455 0.5 10 0.5ZM10.5 11.5C8.016 11.5 6 9.484 6 7C6 4.516 8.016 2.5 10.5 2.5C12.984 2.5 15 4.516 15 7C15 9.484 12.984 11.5 10.5 11.5ZM8 7C8 5.61667 9.11667 4.5 10.5 4.5C11.8833 4.5 13 5.61667 13 7C13 8.38333 11.8833 9.5 10.5 9.5C9.11667 9.5 8 8.38333 8 7Z" fill="#1F2B60"/>
    </svg>

    <!-- Feature truck -->
    <svg
      v-else-if="type === 'feature-truck' || type === 'feature-slot'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.37564 3C5.6299 3 5.02536 3.60454 5.02536 4.35028V13.2142C4.25425 13.2161 3.62974 13.8418 3.62974 14.6134V18.8109H4.32921V19.3006C4.32921 19.687 4.64242 20.0002 5.02879 20.0002H6.07816C6.46453 20.0002 6.77774 19.687 6.77774 19.3006V18.8109H13.7034V19.3006C13.7034 19.687 14.0166 20.0002 14.403 20.0002H15.4523C15.8387 20.0002 16.1519 19.687 16.1519 19.3006V18.8109H16.7819V18.81L17.411 18.6677V17.0304L16.7819 16.7815V14.6134C16.7819 13.9961 16.3821 13.4721 15.8273 13.2863V4.35028C15.8273 3.60454 15.2228 3 14.477 3V13.2142H6.37564V13.2137H14.4731V6.49768C14.4731 5.33857 13.5334 4.39893 12.3743 4.39893H8.10689C7.38822 4.39893 6.75391 4.76016 6.37564 5.31096V3ZM3 17.0304L3.62962 16.7813V18.8101L3 18.6677V17.0304Z" fill="#131315"/>
        <path d="M7.05072 8.40073C7.05072 8.02786 7.35299 7.72559 7.72586 7.72559H13.127C13.4999 7.72559 13.8021 8.02786 13.8021 8.40073V10.4262H7.05072V8.40073Z" fill="white"/>
        <rect x="7.72583" y="14.4766" width="4.72599" height="2.02542" rx="0.559665" fill="white"/>
        <rect x="4.35025" y="16.502" width="2.02542" height="1.35028" rx="0.559665" fill="white"/>
        <rect x="13.8019" y="16.502" width="2.02542" height="1.35028" rx="0.559665" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="20" height="23" fill="white"/>
        </clipPath>
      </defs>
    </svg>

    <!-- <svg
      v-else-if="type === 'feature-security'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <g clip-path="url(#clip1)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M3.12988 7.82959L9.76453 4.88086L16.3992 7.82959V12.2527C16.3992 16.344 13.5684 20.17 9.76453 21.0989C5.96066 20.17 3.12988 16.344 3.12988 12.2527V7.82959ZM14.9249 12.9825H9.76466V6.49532L4.60438 8.78796V12.9899H9.76466V19.5729C12.507 18.7252 14.5342 16.0197 14.9249 12.9825Z" fill="#131315"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white"/></clipPath>
        <clipPath id="clip1"><rect width="18" height="18" fill="white" transform="translate(1.12988 2.88867)"/></clipPath>
      </defs>
    </svg> -->

    <!-- <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg"> -->
    <svg
      v-else-if="type === 'feature-security'"
      :width="width" 
      :height="height"
      viewBox="0 0 21 21"
    >
      <path d="M10.052 19.0347C10.3093 19.1721 10.6321 19.1712 10.8894 19.0339C17.8999 15.2679 18.3978 7.90997 18.3916 5.81785C18.3908 5.4731 18.186 5.16685 17.8701 5.02772V5.02772C13.3488 2.25013 7.64294 2.25324 3.12026 5.0286V5.0286C2.80963 5.16772 2.60663 5.46873 2.60226 5.8091C2.57251 7.89073 2.99163 15.2644 10.052 19.0347ZM7.58976 9.00635L9.59613 11.0127L13.3525 7.25635L14.5898 8.4936L9.59613 13.4872L6.35251 10.2436L7.58976 9.00635Z" fill="#131315"/>
    </svg>


    <svg
      v-else-if="type === 'feature-sanitary'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <g clip-path="url(#clip1)">
          <path d="M9.64422 5.58008V21.3486H11.1295V5.58008H9.64422Z" fill="#131315"/>
          <path d="M15.8023 8.03591C15.0844 8.03591 14.5025 7.45407 14.5025 6.73622C14.5025 6.01849 15.0844 5.43652 15.8023 5.43652C16.52 5.43652 17.1019 6.01849 17.1019 6.73622C17.1019 7.45407 16.52 8.03591 15.8023 8.03591Z" fill="#131315"/>
          <path d="M15.9947 16.2768L15.9942 20.8232C15.9942 21.6411 17.2197 21.6411 17.2197 20.8232L17.2202 16.2768H18.8443L17.1066 10.2485H17.3797L18.4031 13.6921C18.6467 14.4432 19.6778 14.1346 19.4419 13.3304L18.3057 9.58922C18.1838 9.16259 17.6443 8.40625 16.7104 8.40625H15.8492H14.9224C13.9968 8.40625 13.4548 9.16897 13.3147 9.58922L12.178 13.3267C11.9506 14.1305 12.9737 14.4635 13.2173 13.6799L14.2403 10.2485H14.5361L12.7797 16.2768H14.4108V20.8292C14.4108 21.6411 15.6313 21.6371 15.6313 20.8292V16.2768H15.9947Z" fill="#131315"/>
          <path d="M6.52719 8.40137C7.44172 8.40137 8.17722 9.15787 8.17722 10.1015V14.1232C8.17722 14.9051 7.04905 14.9051 7.04905 14.1232V10.4457H6.78197V20.6354C6.78197 21.6808 5.27962 21.6501 5.27962 20.6354V14.67H5.02088V20.6354C5.02088 21.6501 3.51032 21.6808 3.51032 20.6354V10.4457H3.24949V14.1232C3.24949 14.9111 2.12718 14.9111 2.12922 14.1232V10.1255C2.12922 9.25543 2.79539 8.40317 3.79949 8.40317L6.52719 8.40137Z" fill="#131315"/>
          <path d="M5.15767 8.03591C4.4399 8.03591 3.85798 7.45407 3.85798 6.73622C3.85798 6.01849 4.4399 5.43652 5.15767 5.43652C5.8754 5.43652 6.45737 6.01849 6.45737 6.73622C6.45737 7.45407 5.8754 8.03591 5.15767 8.03591Z" fill="#131315"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.555664)"/></clipPath>
        <clipPath id="clip1"><rect width="17.3471" height="16" fill="white" transform="matrix(-1 0 0 1 19.4766 5.43652)"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-comfort'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <g clip-path="url(#clip1)">
          <g clip-path="url(#clip2)">
            <path d="M4.28058 8.64364C4.82184 8.71604 5.40653 8.94151 5.77266 9.31729C6.57799 10.1426 6.83655 11.3286 6.91171 12.358C7.18544 12.2952 7.29714 12.2559 7.58604 12.2559H12.929C13.1841 12.2559 13.2613 12.287 13.5033 12.3345C13.5819 11.3141 13.8439 10.1254 14.6465 9.30901C15.012 8.93806 15.5932 8.71535 16.131 8.64296C14.7713 7.51493 12.6235 6.78613 10.2061 6.78613C7.78875 6.78613 5.64096 7.51493 4.28058 8.64364Z" fill="#131315"/>
            <path d="M16.5015 9.29324C14.3875 9.29324 14.3158 12.6477 14.3289 13.4544C13.9421 13.2406 13.4573 13.1124 12.9292 13.1124H7.58626C7.00984 13.1124 6.48444 13.2654 6.08246 13.5157C6.09901 12.8359 6.08315 9.29324 3.91123 9.29324C3.91123 9.29324 2.13025 9.16706 2.13025 10.3013C2.13025 11.4941 3.37342 11.3093 3.37342 11.3093C3.37342 11.3093 3.39617 17.1811 4.31734 17.1811H4.59935V17.9796H5.86734V17.1811H14.5081V17.9796H15.7754V17.1811H16.1043V17.179C17.0165 17.1397 17.0393 11.3093 17.0393 11.3093C17.0393 11.3093 18.2825 11.4941 18.2825 10.3013C18.2825 9.1712 16.5015 9.29324 16.5015 9.29324Z" fill="#131315"/>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.555664)"/></clipPath>
        <clipPath id="clip1"><rect width="18" height="18" fill="white" transform="translate(1.12988 3.44434)"/></clipPath>
        <clipPath id="clip2"><rect width="16.1522" height="11.1933" fill="white" transform="translate(2.12988 6.78516)"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-health'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.7969 4.99219H7.46352V10.3258H2.12988V15.6592H7.46352V20.9922H12.7969V15.6592H18.1299V10.3258H12.7969V4.99219Z" fill="#131315"/>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.111328)"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-food'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0134 10.9905C15.6542 12.3497 13.8162 12.7771 12.5083 12.1702L11.2516 13.4268L17.1331 19.3083L15.9278 20.5137L10.0463 14.6322L4.15627 20.5051L2.95091 19.2998L8.85039 13.4003L7.92159 12.5079L6.71196 13.7175L3.13007 10.1442C1.79649 8.80203 1.79649 6.63923 3.13007 5.30564L9.13122 11.2982L10.0299 12.2208L11.2944 10.9563C10.6874 9.64834 11.1149 7.81038 12.4741 6.45115C14.1154 4.81836 16.4578 4.51061 17.7059 5.75871C18.9625 7.01536 18.6462 9.35769 17.0134 10.9905Z" fill="#131315"/>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.111328)"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-shop'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5097 14.4511L5.67621 15.9666H14.7689V17.482H3.11511L5.37312 13.3827L2.64532 7.63165H1.12988V6.11621H3.60763L4.31989 7.63165H16.8147L13.4807 13.6707C13.2231 14.1405 12.723 14.4511 12.1547 14.4511H6.5097ZM5.67564 18.2394C4.84215 18.2394 4.16777 18.9214 4.16777 19.7549C4.16777 20.5884 4.84215 21.2703 5.67564 21.2703C6.50913 21.2703 7.19108 20.5884 7.19108 19.7549C7.19108 18.9214 6.50913 18.2394 5.67564 18.2394ZM13.2523 18.2394C12.4188 18.2394 11.7445 18.9214 11.7445 19.7549C11.7445 20.5884 12.4188 21.2703 13.2523 21.2703C14.0858 21.2703 14.7678 20.5884 14.7678 19.7549C14.7678 18.9214 14.0858 18.2394 13.2523 18.2394Z" fill="#131315"/>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.389648)"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-services'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
    >
      <g clip-path="url(#clip0)">
        <path d="M11.8043 13.3053L9.96585 15.1437L16.451 21.6289L18.2894 19.7905L11.8043 13.3053Z" fill="#131315"/>
        <path d="M14.4761 11.9502C16.1488 11.9502 17.5094 10.5895 17.5094 8.91692C17.5094 8.41426 17.3707 7.94628 17.1541 7.53029L14.8141 9.87022L13.5228 8.57893L15.8628 6.239C15.4468 6.02234 14.9788 5.88367 14.4761 5.88367C12.8035 5.88367 11.4429 7.2443 11.4429 8.91692C11.4429 9.27224 11.5122 9.61023 11.6249 9.92222L10.0216 11.5255L8.47899 9.98288L9.09431 9.36757L7.87235 8.14561L9.70962 6.30833C8.69565 5.29436 7.04904 5.29436 6.03507 6.30833L2.96716 9.37624L4.18912 10.5982H1.7452L1.12988 11.2135L4.19779 14.2814L4.8131 13.6661V11.2135L6.03507 12.4355L6.65038 11.8202L8.193 13.3628L1.7712 19.7846L3.60847 21.6219L13.4708 11.7682C13.7828 11.8808 14.1208 11.9502 14.4761 11.9502Z" fill="#131315"/>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.666992)"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-parking' || type === 'feature-security_level'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 24"
      fill="none"
    >
      <g clip-path="url(#clip0)">
        <rect x="1" y="5.27734" width="16" height="16" rx="3.2" fill="#131315"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.87912 14.6898C10.1996 14.6898 11.2393 14.4453 11.9968 13.8844C12.3672 13.6174 12.6626 13.2777 12.8596 12.8922C13.0565 12.5066 13.1496 12.0858 13.1316 11.6628C13.1422 11.0716 12.96 10.4903 12.6069 9.98867C12.2495 9.48811 11.7341 9.0916 11.1248 8.84838C10.4322 8.57851 9.67998 8.45032 8.92391 8.47334H4.50977V18.0643H7.1143V14.6898H8.87912ZM7.21582 10.2445H9.05593V10.2466C9.26161 10.233 9.46813 10.2598 9.66082 10.325C9.85352 10.3901 10.0277 10.4921 10.1709 10.6237C10.4565 10.9109 10.6037 11.2858 10.581 11.6681C10.5935 11.8401 10.5644 12.0125 10.4957 12.1738C10.4271 12.335 10.3204 12.4814 10.1829 12.6033C9.85689 12.8356 9.44141 12.946 9.02498 12.9108H7.21582V10.2445Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.277344)"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-booking' || type === 'feature-bookable'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 23"
      fill="none"
    >
      <g clip-path="url(#clip0)">
        <path d="M4 4.91667C4 4.41041 4.41041 4 4.91667 4H11.7917L15.4583 8.35417V17.75C15.4583 18.2563 15.0479 18.6667 14.5417 18.6667H4.91667C4.41041 18.6667 4 18.2563 4 17.75V4.91667Z" fill="#131315" stroke="#131315" stroke-width="1.83333"/>
        <path d="M12.25 12.0664H6.75" stroke="white" stroke-width="1.83333" stroke-linecap="square"/>
        <path d="M12.25 15H6.75" stroke="white" stroke-width="1.83333" stroke-linecap="square"/>
        <path d="M8.125 9.13281H7.4375H6.75" stroke="white" stroke-width="1.83333" stroke-linecap="square"/>
        <rect x="10.4165" y="3.08398" width="1.83333" height="6.41667" fill="white"/>
        <rect x="16.375" y="7.66797" width="1.83333" height="5.95833" transform="rotate(90 16.375 7.66797)" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white"/></clipPath>
      </defs>
    </svg>

    <svg
      v-else-if="type === 'feature-distance'"
      :width="width" 
      :height="height"
      viewBox="0 0 20 24"
      fill="none"
    >
      <g clip-path="url(#clip0)">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5073 4.86221C13.8776 5.234 16.5529 7.90923 16.9247 11.2795H18.5896V12.896H16.9247C16.5529 16.2663 13.8776 18.9415 10.5073 19.3133V20.9783H8.89087V19.3133C5.52056 18.9415 2.84533 16.2663 2.47354 12.896H0.808594V11.2795H2.47354C2.84533 7.90923 5.52056 5.234 8.89087 4.86221V3.19727H10.5073V4.86221ZM4.04142 12.0873C4.04142 15.2151 6.57118 17.7449 9.69902 17.7449C12.8269 17.7449 15.3566 15.2151 15.3566 12.0873C15.3566 8.95944 12.8269 6.42969 9.69902 6.42969C6.57118 6.42969 4.04142 8.95944 4.04142 12.0873Z" fill="#131315"/>
        <path d="M16.9247 11.2795L16.4277 11.3344L16.4768 11.7795H16.9247V11.2795ZM10.5073 4.86221H10.0073V5.31009L10.4525 5.3592L10.5073 4.86221ZM18.5896 11.2795H19.0896V10.7795H18.5896V11.2795ZM18.5896 12.896V13.396H19.0896V12.896H18.5896ZM16.9247 12.896V12.396H16.4768L16.4277 12.8412L16.9247 12.896ZM10.5073 19.3133L10.4525 18.8163L10.0073 18.8654V19.3133H10.5073ZM10.5073 20.9783V21.4783H11.0073V20.9783H10.5073ZM8.89087 20.9783H8.39087V21.4783H8.89087V20.9783ZM8.89087 19.3133H9.39087V18.8654L8.94569 18.8163L8.89087 19.3133ZM2.47354 12.896L2.97053 12.8412L2.92142 12.396H2.47354V12.896ZM0.808594 12.896H0.308594V13.396H0.808594V12.896ZM0.808594 11.2795V10.7795H0.308594V11.2795H0.808594ZM2.47354 11.2795V11.7795H2.92142L2.97053 11.3344L2.47354 11.2795ZM8.89087 4.86221L8.94569 5.3592L9.39087 5.31009V4.86221H8.89087ZM8.89087 3.19727V2.69727H8.39087V3.19727H8.89087ZM10.5073 3.19727H11.0073V2.69727H10.5073V3.19727ZM17.4216 11.2247C17.0242 7.62167 14.1652 4.76269 10.5621 4.36523L10.4525 5.3592C13.5901 5.70531 16.0816 8.19679 16.4277 11.3344L17.4216 11.2247ZM18.5896 10.7795H16.9247V11.7795H18.5896V10.7795ZM19.0896 12.896V11.2795H18.0896V12.896H19.0896ZM16.9247 13.396H18.5896V12.396H16.9247V13.396ZM10.5621 19.8103C14.1652 19.4128 17.0242 16.5539 17.4216 12.9508L16.4277 12.8412C16.0816 15.9787 13.5901 18.4702 10.4525 18.8163L10.5621 19.8103ZM11.0073 20.9783V19.3133H10.0073V20.9783H11.0073ZM8.89087 21.4783H10.5073V20.4783H8.89087V21.4783ZM8.39087 19.3133V20.9783H9.39087V19.3133H8.39087ZM1.97656 12.9508C2.37402 16.5539 5.233 19.4128 8.83605 19.8103L8.94569 18.8163C5.80812 18.4702 3.31664 15.9787 2.97053 12.8412L1.97656 12.9508ZM0.808594 13.396H2.47354V12.396H0.808594V13.396ZM0.308594 11.2795V12.896H1.30859V11.2795H0.308594ZM2.47354 10.7795H0.808594V11.7795H2.47354V10.7795ZM8.83605 4.36523C5.233 4.76269 2.37402 7.62167 1.97656 11.2247L2.97053 11.3344C3.31664 8.19679 5.80812 5.70531 8.94569 5.3592L8.83605 4.36523ZM8.39087 3.19727V4.86221H9.39087V3.19727H8.39087ZM10.5073 2.69727H8.89087V3.69727H10.5073V2.69727ZM11.0073 4.86221V3.19727H10.0073V4.86221H11.0073ZM9.69902 17.2449C6.84732 17.2449 4.54142 14.939 4.54142 12.0873H3.54142C3.54142 15.4913 6.29503 18.2449 9.69902 18.2449V17.2449ZM14.8566 12.0873C14.8566 14.939 12.5507 17.2449 9.69902 17.2449V18.2449C13.103 18.2449 15.8566 15.4913 15.8566 12.0873H14.8566ZM9.69902 6.92969C12.5507 6.92969 14.8566 9.23558 14.8566 12.0873H15.8566C15.8566 8.6833 13.103 5.92969 9.69902 5.92969V6.92969ZM4.54142 12.0873C4.54142 9.23558 6.84732 6.92969 9.69902 6.92969V5.92969C6.29503 5.92969 3.54142 8.6833 3.54142 12.0873H4.54142Z" fill="black"/>
        <circle cx="9.69895" cy="12.0881" r="1.87717" fill="#131315"/>
      </g>
      <defs>
        <clipPath id="clip0"><rect width="20" height="23" fill="white" transform="translate(0 0.388672)"/></clipPath>
      </defs>
    </svg>


    <!-- <svg
      v-else-if="type === 'filters'"
      :width="width" 
      :height="height"
      viewBox="0 0 21 18"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0616 9.24942C14.8984 9.24942 16.461 10.4234 17.0401 12.0619L18.6863 12.0617C19.4628 12.0617 20.0924 12.6913 20.0924 13.4679C20.0924 14.2445 19.4628 14.874 18.6863 14.874L17.0396 14.8753C16.4601 16.5131 14.8979 17.6863 13.0616 17.6863C11.2254 17.6863 9.66312 16.5131 9.08366 14.8753L1.8124 14.874C1.03581 14.874 0.40625 14.2445 0.40625 13.4679C0.40625 12.6913 1.03581 12.0617 1.8124 12.0617L9.08317 12.0619C9.66224 10.4234 11.2248 9.24942 13.0616 9.24942ZM13.0616 11.3587C11.8967 11.3587 10.9524 12.303 10.9524 13.4679C10.9524 14.6328 11.8967 15.5771 13.0616 15.5771C14.2265 15.5771 15.1709 14.6328 15.1709 13.4679C15.1709 12.303 14.2265 11.3587 13.0616 11.3587ZM7.43702 0.8125C9.27381 0.8125 10.8364 1.98643 11.4155 3.62493L18.6863 3.62481C19.4628 3.62481 20.0924 4.25436 20.0924 5.03096C20.0924 5.80756 19.4628 6.43712 18.6863 6.43712L11.415 6.43838C10.8355 8.07616 9.27329 9.24942 7.43702 9.24942C5.60075 9.24942 4.03851 8.07616 3.45904 6.43838L1.8124 6.43712C1.03581 6.43712 0.40625 5.80756 0.40625 5.03096C0.40625 4.25436 1.03581 3.62481 1.8124 3.62481L3.45855 3.62493C4.03762 1.98643 5.60023 0.8125 7.43702 0.8125ZM7.43702 2.92173C6.27212 2.92173 5.32779 3.86607 5.32779 5.03096C5.32779 6.19586 6.27212 7.14019 7.43702 7.14019C8.60192 7.14019 9.54625 6.19586 9.54625 5.03096C9.54625 3.86607 8.60192 2.92173 7.43702 2.92173Z"/>
    </svg> -->

    <!-- Help -->
    <svg 
      v-else-if="type === 'help'"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 20"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM9 17V15H11V17H9ZM12.17 10.17L13.07 9.25C13.64 8.68 14 7.88 14 7C14 4.79 12.21 3 10 3C7.79 3 6 4.79 6 7H8C8 5.9 8.9 5 10 5C11.1 5 12 5.9 12 7C12 7.55 11.78 8.05 11.41 8.41L10.17 9.67C9.45 10.4 9 11.4 9 12.5V13H11C11 11.5 11.45 10.9 12.17 10.17Z"/>
    </svg>

    <svg
      v-else-if="type === 'info'"
      :width="width" 
      :height="height"
      viewBox="0 0 24 24"
    >
      <path d="M12.8571 17.1429V10.2857H9.42858V12H11.1429V17.1429H8.57143V18.8571H15.4286V17.1429H12.8571Z"/>
      <path d="M12 5.14286C11.7457 5.14286 11.4971 5.21827 11.2857 5.35954C11.0743 5.50082 10.9095 5.70162 10.8122 5.93655C10.7148 6.17149 10.6894 6.43 10.739 6.67941C10.7886 6.92881 10.9111 7.1579 11.0909 7.33771C11.2707 7.51752 11.4998 7.63998 11.7492 7.68959C11.9986 7.7392 12.2571 7.71373 12.492 7.61642C12.727 7.51911 12.9278 7.35431 13.069 7.14288C13.2103 6.93145 13.2857 6.68287 13.2857 6.42858C13.2857 6.08758 13.1503 5.76056 12.9091 5.51944C12.668 5.27832 12.341 5.14286 12 5.14286Z"/>
      <path d="M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519943 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693605 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519943 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24ZM12 1.71429C9.96568 1.71429 7.97704 2.31754 6.28557 3.44775C4.59409 4.57795 3.27575 6.18436 2.49724 8.06383C1.71874 9.9433 1.51505 12.0114 1.91193 14.0066C2.3088 16.0019 3.28842 17.8346 4.72691 19.2731C6.16539 20.7116 7.99813 21.6912 9.99336 22.0881C11.9886 22.485 14.0567 22.2813 15.9362 21.5028C17.8156 20.7243 19.4221 19.4059 20.5523 17.7144C21.6825 16.023 22.2857 14.0343 22.2857 12C22.2857 9.27206 21.202 6.65585 19.2731 4.72691C17.3442 2.79796 14.7279 1.71429 12 1.71429Z"/>
    </svg>

    
    <!-- List parking -->
    <svg 
      v-else-if="type === 'list-parking'"
      :width="width" 
      :height="height" 
      viewBox="0 0 24 24"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 9H7.5V5H3.5V9ZM7.5 14H3.5V10H7.5V14ZM7.5 19H3.5V15H7.5V19ZM20.5 14H8.5V10H20.5V14ZM8.5 19H20.5V15H8.5V19ZM8.5 9V5H20.5V9H8.5Z"/>
    </svg>

    <!-- Logo -->
    <svg 
      v-else-if="type === 'logo'"
      :width="width" 
      :height="height" 
      viewBox="0 0 45 42"
    >
      <g clip-path="url(#clip0)">
        <path d="M11.1671 15.0231C15.0407 15.0231 16.995 15.0231 20.8686 15.0231C20.8686 16.07 20.8686 16.576 20.8686 17.6229C19.5948 17.6229 18.9667 17.6229 17.7104 17.6404C17.7104 21.6535 17.7104 23.6427 17.6929 27.6559C16.3494 27.7082 15.6689 27.7257 14.3079 27.8129C14.3079 23.7648 14.3253 21.7408 14.3253 17.6753C13.0516 17.6927 12.4234 17.6927 11.1671 17.7276C11.1497 16.6458 11.1497 16.1049 11.1671 15.0231Z" fill="white"/>
        <path d="M44.9655 12.7024C44.9655 11.4287 43.936 10.3992 42.6623 10.3992H30.2912L28.7557 7.31078H32.5246C32.5246 7.31078 31.216 4.74584 30.2563 2.79159C29.0523 0.313887 27.0806 -0.0001885 25.6498 0.0172601H16.9255C15.6518 0.0172601 14.6223 1.04673 14.6223 2.32048H25.6498C26.5223 2.28558 27.6215 2.7218 28.0752 3.66402C28.494 4.50156 28.7383 5.00757 28.7383 5.00757H25.6498C23.3466 5.00757 22.8581 6.59539 22.4567 7.31078H26.1559L28.8429 12.7024H44.9655Z" fill="white"/>
        <path d="M17.9197 3.8559L14.6568 10.3817H2.30322C1.02947 10.3817 0 11.4111 0 12.7023H16.14L20.5545 3.8559H17.9197Z" fill="white"/>
        <path d="M22.9976 42.1557C22.666 42.3476 22.2822 42.3476 21.9506 42.1557C18.5133 40.0444 13.9417 38.0029 10.9406 37.5492L9.50977 37.3398L12.6854 30.9711C12.6854 30.9711 18.9495 29.6973 25.5625 30.8839C25.5625 30.8839 25.3182 32.9602 23.1895 32.716C17.9549 32.1402 15.3551 32.5938 14.343 32.8556L12.982 35.595C15.7215 36.258 19.0193 37.8284 22.003 39.5384C22.2996 39.7129 22.666 39.7129 22.9801 39.5384C25.894 37.8808 29.122 36.3802 32.0185 35.6648L29.3489 30.3255H30.2911C31.2508 30.3255 32.2279 30.8141 32.6466 31.7388L35.4384 37.3398L33.8506 37.619C30.5528 38.2123 26.4 40.0618 22.9976 42.1557Z" fill="white"/>
        <path d="M30.4828 23.695C30.4828 23.695 30.6747 23.6776 30.8318 23.6427C31.7566 23.3286 32.2451 22.5783 32.2451 21.4442C32.2451 19.8738 32.2451 19.0886 32.2451 17.5182C32.2451 15.913 31.268 15.0231 29.4882 15.0231C26.4173 15.0231 22.5437 15.0231 22.5437 15.0231C22.5437 15.0231 22.5437 15.3197 22.5437 17.6578H25.9287C25.9287 17.6578 27.3944 17.6404 28.389 17.6578C28.7205 17.6578 28.895 17.8323 28.895 18.1115C28.895 19.1409 28.895 19.6644 28.895 20.7113C28.895 21.0079 28.703 21.165 28.389 21.1475C27.4119 21.1301 26.9233 21.1126 25.9287 21.1126C25.9287 20.5543 25.9287 19.0014 25.9287 18.5826H22.5088C22.5088 21.1475 22.5088 25.3527 22.5088 27.5686C23.8523 27.5686 24.5503 27.5861 25.8938 27.621C25.8938 26.0506 25.8938 23.7299 25.8938 23.7299C25.8938 23.7299 26.5045 23.7125 27.1152 23.7299C27.883 25.2654 28.3192 26.1727 29.1218 27.7431C30.5177 27.8129 31.2157 27.8304 32.6115 27.9351C31.774 26.2774 30.4828 23.695 30.4828 23.695Z" fill="white"/>
        <path d="M4.46711 25.9634C4.27517 25.9808 4.17048 25.9983 3.90875 26.0332C3.57723 26.0681 3.40274 25.911 3.40274 25.597C3.40274 22.683 3.40274 21.2174 3.40274 18.3034C3.40274 17.9894 3.59467 17.7974 3.90875 17.7974C4.15303 17.7974 4.25772 17.78 4.46711 17.78V14.9359H2.79204C1.01228 14.9359 0.0351562 15.913 0.0351562 17.6927V26.6788C0.0351562 28.4585 1.01228 29.2786 2.77459 29.0343C3.47253 28.9296 3.9262 28.8599 4.46711 28.7901V25.9634Z" fill="white"/>
        <path d="M6.9796 14.9359H5.23473V17.7451C5.44412 17.7451 5.56626 17.7276 5.84544 17.7276C6.17696 17.7276 6.35145 17.8847 6.35145 18.1987C6.35145 21.0429 6.35145 22.4562 6.334 25.3003C6.334 25.6144 6.14206 25.7889 5.82799 25.8238C5.54881 25.8412 5.44412 25.8761 5.21729 25.8936V28.7028C5.75819 28.633 6.21186 28.5807 6.9447 28.4934C8.89894 28.1968 9.70158 27.3244 9.70158 25.6842C9.70158 22.3864 9.71903 20.7462 9.71903 17.4485C9.73648 15.8257 8.75936 14.9359 6.9796 14.9359Z" fill="white"/>
        <path d="M41.5275 15.0231H35.4205C35.4205 15.5989 35.9788 16.3317 36.6419 16.5411C35.403 21.2522 34.8272 23.4508 33.5884 27.9874C34.9843 28.0921 35.6648 28.1619 37.0607 28.3015C37.2875 27.2197 37.3922 26.6788 37.619 25.5969L39.2068 17.8323C39.2592 17.8323 39.2766 17.8323 39.329 17.8323C39.7477 19.8912 39.9571 20.9207 40.3759 23.032C39.6605 22.9796 39.6082 22.9622 38.9975 22.9273L38.474 25.6667C39.5035 25.754 39.7826 25.8063 40.9517 25.9285C41.1785 27.0975 41.3007 27.6733 41.5275 28.8424C42.9059 29.0343 43.6039 29.1216 44.9823 29.3484C43.6039 23.3984 42.9234 20.5543 41.5275 15.0231Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="45" height="42" fill="white"/>
        </clipPath>
      </defs>
    </svg>

    <!-- Message -->
    <svg 
      v-else-if="type === 'message'"
      :width="width" 
      :height="height" 
      viewBox="0 0 28 24"
    >
      <g filter="url(#filter0_d)">
        <rect width="23.8" height="23.8" rx="11.9"/>
      </g>
      <path d="M18 14.2058L14.4864 13.7991L12.8062 15.4793C10.9194 14.5192 9.37258 12.9791 8.4125 11.0856L10.0993 9.39874L9.69261 5.89844H6.01896C5.63226 12.6857 11.2127 18.2662 18 17.8795V14.2058Z" fill="white"/>
      <defs>
        <filter id="filter0_d" x="-4" y="-2" width="31.8" height="31.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
          <feOffset dy="2"/>
          <feGaussianBlur stdDeviation="2"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
      </defs>
    </svg>

    <!-- Notification -->
    <svg 
      v-else-if="type === 'notification'"
      :width="width" 
      :height="height" 
      viewBox="0 0 19 23"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.25 10.0938V15.7188L18.5 17.9688V19.0938H0.5V17.9688L2.75 15.7188V10.0938C2.75 6.62875 4.58375 3.74875 7.8125 2.98375V0.53125H11.1875V2.98375C14.405 3.74875 16.25 6.64 16.25 10.0938ZM11.75 20.2188C11.75 21.4562 10.7375 22.4688 9.5 22.4688C8.25125 22.4688 7.25 21.4562 7.25 20.2188H11.75Z"/>
    </svg>
   
    <!-- Parking -->
    <svg 
      v-else-if="type === 'parking'"
      :width="width" 
      :height="height" 
      viewBox="0 0 24 24"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7.15C4.56 4.59 8.1 3 12 3C15.9 3 19.44 4.59 22 7.14L17 12.14C15.72 10.86 13.95 10.07 12 10.07C10.05 10.07 8.28 10.87 7 12.15L2 7.15ZM8 17C8 14.7909 9.79086 13 12 13C14.2091 13 16 14.7909 16 17C16 19.2091 14.2091 21 12 21C9.79086 21 8 19.2091 8 17Z"/>
    </svg>
    
    <!-- Parking Icon -->
    <svg 
      v-else-if="type === 'parking-i'"
      :width="width" 
      :height="height" 
      viewBox="0 0 14 18"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 0H7.5C10.81 0 13.5 2.69 13.5 6C13.5 9.31 10.81 12 7.5 12H4.5V18H0.5V0ZM4.5 8H7.7C8.8 8 9.7 7.1 9.7 6C9.7 4.9 8.8 4 7.7 4H4.5V8Z"/>
    </svg>

    <!-- Pass -->
    <svg 
      v-else-if="type === 'pass'"
      :width="width" 
      :height="height" 
      viewBox="0 0 24 24"
    >
      <path d="M22 10V6C22 4.9 21.1 4 20 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM20 8.54C18.81 9.23 18 10.53 18 12C18 13.47 18.81 14.77 20 15.46V18H4V15.46C5.19 14.77 6 13.47 6 12C6 10.52 5.2 9.23 4.01 8.54L4 6H20V8.54ZM9.07 16L12 14.12L14.93 16L14.04 12.64L16.73 10.44L13.26 10.23L12 7L10.73 10.22L7.26 10.43L9.95 12.63L9.07 16Z"/>
    </svg>

    <!-- Phone -->
    <svg 
      v-else-if="type === 'phone'"
      :width="width" 
      :height="height" 
      viewBox="0 0 18 18"
    >
      <path d="M17.9992 12.461L12.7292 11.851L10.2092 14.371C7.37917 12.931 5.05917 10.621 3.61917 7.78098L6.14917 5.25098L5.53917 0.000976562H0.0291701C-0.55083 10.181 7.81917 18.551 17.9992 17.971V12.461Z"/>
    </svg>

    <!-- QR -->
    <svg
      v-else-if="type === 'qr'"
      :width="width" 
      :height="height" 
      viewBox="0 0 21 21"
    >
      <path d="M7.70001 5V8H4.70001V5H7.70001ZM9.20001 3.5H3.20001V9.5H9.20001V3.5ZM7.70001 13V16H4.70001V13H7.70001ZM9.20001 11.5H3.20001V17.5H9.20001V11.5ZM15.7 5V8H12.7V5H15.7ZM17.2 3.5H11.2V9.5H17.2V3.5ZM11.2 11.5H12.7V13H11.2V11.5ZM12.7 13H14.2V14.5H12.7V13ZM14.2 11.5H15.7V13H14.2V11.5ZM11.2 14.5H12.7V16H11.2V14.5ZM12.7 16H14.2V17.5H12.7V16ZM14.2 14.5H15.7V16H14.2V14.5ZM15.7 13H17.2V14.5H15.7V13ZM15.7 16H17.2V17.5H15.7V16ZM20.2 5.5H18.2V2.5H15.2V0.5H20.2V5.5ZM20.2 20.5V15.5H18.2V18.5H15.2V20.5H20.2ZM0.200012 20.5H5.20001V18.5H2.20001V15.5H0.200012V20.5ZM0.200012 0.5V5.5H2.20001V2.5H5.20001V0.5H0.200012Z"/>
    </svg>

    <svg
      v-else-if="type === 'qr-bis'"
      :width="width" 
      :height="height"
      viewBox="0 0 22 22"
    >
      <path d="M6.88713 21.9685H0.0318604V15.1132H6.88713V21.9685ZM5.51608 16.4843H1.40291V20.5974H5.51608V16.4843Z"/>
      <path d="M4.14511 19.2262H2.77405V17.8552H4.14511V19.2262Z"/>
      <path d="M15.1133 21.9688V15.1135H21.9686V21.9688H15.1133ZM20.5975 16.4845H16.4843V20.5977H20.5975V16.4845Z"/>
      <path d="M19.2258 19.2262H17.8547V17.8552H19.2258V19.2262Z"/>
      <path d="M0.0314941 0.0316467H6.88676V6.88696H0.0314941V0.0316467ZM1.40255 5.5159H5.51571V1.40271H1.40255V5.5159Z"/>
      <path d="M4.14511 4.14445H2.77405V2.77336H4.14511V4.14445Z"/>
      <path d="M13.7416 21.9688H10.9995V20.5977H13.7416V21.9688Z"/>
      <path d="M11.0002 16.4843H12.3712V17.8554H13.7423V19.2264H9.62911V20.5974H8.25806V19.2264V18.5409V17.8554H11.0002V16.4843Z"/>
      <path d="M9.62912 16.4847H8.25806V15.1136H9.62912V16.4847Z"/>
      <path d="M13.7423 15.1135H12.3712V13.7424H8.25806V12.3714H13.7423V15.1135Z"/>
      <path d="M1.40255 9.62904H2.77361V11.0001H1.40255V13.7422H0.0314941V8.25798H1.40255V9.62904Z"/>
      <path d="M4.14511 13.7422H2.77405V12.3712H4.14511V13.7422Z"/>
      <path d="M8.25745 8.25798H10.9996V9.62904H9.6285V11.0001H6.8864V13.7422H5.51534V11.0001H4.14429V8.25798H5.51534V9.62904H6.20087H6.8864H8.25745V8.25798Z"/>
      <path d="M13.7418 10.9997H12.3707V8.25758H13.7418V10.9997Z"/>
      <path d="M12.3712 6.88696H8.25806V5.5159H11.0002V1.40271H8.25806V0.0316467H12.3712V1.40271H15.1133V2.77377H12.3712V6.88696Z"/>
      <path d="M9.62912 4.14445H8.25806V2.77336H9.62912V4.14445Z"/>
      <path d="M15.1131 6.88696H13.7421V4.14488H15.1131V6.88696Z"/>
      <path d="M20.5977 4.14445H16.4845V0.0312653H17.8556V2.77339H20.5977V4.14445Z"/>
      <path d="M21.9682 1.40289H19.2261V0.0318756H21.9682V1.40289Z"/>
      <path d="M21.9683 6.88696H20.5973V5.51585H21.9683V6.88696Z"/>
      <path d="M16.4843 5.51631H17.8554V9.62946H15.1133V8.25841H16.4843V5.51631Z"/>
      <path d="M19.2265 12.3712H17.8554V13.7422H16.4843V12.3712H15.1133V11.0001H20.5975V12.3712H21.9686V13.7422H19.2265V12.3712Z"/>
      <path d="M21.9682 9.62946H19.2261V8.25839H21.9682V9.62946Z"/>
    </svg>


    <!-- Review -->
    <svg 
      v-else-if="type === 'review'"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 20"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M20 0H0V20L4 16H20V0ZM4 12V9.53L10.88 2.65C11.08 2.45 11.39 2.45 11.59 2.65L13.36 4.42C13.56 4.62 13.56 4.93 13.36 5.13L6.47 12H4ZM8.5 12H16V10H10.5L8.5 12Z"/>
    </svg>

    <!-- Search -->
    <svg 
      v-else-if="type === 'search'"
      :width="width" 
      :height="height" 
      viewBox="0 0 14 14"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5.93603 11.8871C7.25711 11.8871 8.4924 11.4405 9.4875 10.7018L12.1726 13.3902C12.5088 13.7269 13.0544 13.7269 13.3906 13.3902C13.7269 13.0535 13.7262 12.5079 13.389 12.1721L10.7056 9.49939C11.4434 8.50307 11.8895 7.28344 11.8895 5.94356C11.8895 2.66258 9.23015 0 5.95319 0C2.67623 0 -0.000244141 2.67975 -0.000244141 5.94356C-0.000244141 9.20736 2.67623 11.8871 5.93603 11.8871ZM6.03726 1.75C8.40758 1.75 10.3248 3.60849 10.3248 5.90625C10.3248 8.20401 8.40758 10.0625 6.03726 10.0625C3.66693 10.0625 1.74976 8.20401 1.74976 5.90625C1.74976 3.60849 3.68436 1.75 6.03726 1.75Z"/>
    </svg>
    
    <!-- Security -->
    <svg
      v-else-if="type === 'security'"
      :width="width" 
      :height="height" 
      viewBox="0 0 24 24"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3 5L12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5ZM19 11.99H12V3.19L5 6.3V12H12V20.93C15.72 19.78 18.47 16.11 19 11.99Z"/>
    </svg>

    <!-- Settings -->
    <svg 
      v-else-if="type === 'settings'"
      :width="width" 
      :height="height" 
      viewBox="0 0 20 20"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17.425 11.01L17.435 10.99L19.545 12.65C19.735 12.79 19.875 12.91 19.875 12.91L17.445 17.11L14.565 15.96L14.585 15.92C14.055 16.33 13.475 16.67 12.855 16.93H12.865L12.485 19.58C12.455 19.82 12.425 20 12.425 20H7.57499L7.12499 16.92H7.15499C6.52499 16.66 5.95499 16.32 5.42499 15.91L5.44499 15.95L2.56499 17.1L0.13499 12.9C0.13499 12.9 0.27499 12.79 0.46499 12.64L2.56499 10.99L2.57499 11.01C2.52499 10.68 2.49499 10.34 2.49499 10C2.49499 9.66 2.52499 9.34 2.56499 9.01L2.55499 9.03L0.11499 7.11L2.55499 2.89L5.43499 4.06L5.42499 4.07C5.94499 3.67 6.51499 3.33 7.13499 3.07H7.12499L7.56499 0H12.435L12.895 3.06H12.885C13.505 3.32 14.075 3.66 14.595 4.06L14.585 4.05L17.455 2.89L19.885 7.11L17.445 9.03L17.435 9.01C17.475 9.34 17.505 9.66 17.505 10C17.505 10.34 17.465 10.68 17.425 11.01ZM6.49499 10C6.49499 11.93 8.06499 13.5 9.99499 13.5C11.925 13.5 13.495 11.93 13.495 10C13.495 8.07 11.925 6.5 9.99499 6.5C8.06499 6.5 6.49499 8.07 6.49499 10Z"/>
    </svg>

    <!-- Star -->
    <svg
      v-else-if="type === 'star'"
      :width="width" 
      :height="height"
      viewBox="0 0 15 13"
    >
      <path d="M7.29409 0L9.63353 3.98865L14.1764 4.96556L11.0794 8.40759L11.5476 13L7.29409 11.1386L3.04057 13L3.5088 8.40759L0.411743 4.96556L4.95465 3.98865L7.29409 0Z"/>
    </svg>

    <!-- Success -->
    <svg 
      v-else-if="type === 'notification-success'"
      :width="width" 
      :height="height" 
      viewBox="0 0 141 140" 
    >
      <g clip-path="url(#succesnot)">
        <path d="M40.8088 57.9679L60.6562 77.7292L100.191 38.2804C106.899 44.9877 106.899 55.8625 100.191 62.5698L60.6562 102.105L40.8088 82.2573C34.1014 75.55 34.1014 64.6752 40.8088 57.9679Z" fill="#00A963"/>
        <circle cx="71" cy="70" r="70" fill="#2DCA73"/>
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="1" y="0" width="140" height="140">
        <circle cx="71" cy="70" r="70" fill="white"/>
        </mask>
        <g mask="url(#mask0)">
        <rect x="29" y="42.0002" width="84" height="101.5" rx="2.01923" fill="white"/>
        <rect x="37.75" y="78.7502" width="66.5" height="7" rx="3.5" fill="#ADB0BA" fill-opacity="0.4"/>
        <rect x="37.75" y="92.7507" width="66.5" height="7" rx="3.5" fill="#ADB0BA" fill-opacity="0.4"/>
        <rect x="37.75" y="106.75" width="43.75" height="7" rx="3.5" fill="#ADB0BA" fill-opacity="0.4"/>
        </g>
        <g filter="url(#filter0_dsucess)">
        <circle cx="71" cy="41.9996" r="21" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M65.2476 38.7905C64.5695 38.1019 63.4615 38.0933 62.7728 38.7714C62.0841 39.4495 62.0755 40.5575 62.7536 41.2462L69.3014 47.8962L79.2106 37.9871C79.894 37.3037 79.894 36.1957 79.2106 35.5122C78.5271 34.8288 77.4191 34.8288 76.7357 35.5122L69.3207 42.9272L65.2476 38.7905Z" fill="white"/>
        <path d="M62.4515 38.0826L68.5001 44.1051L80.5488 32.0827V32.0827C82.5929 34.1268 82.5929 37.441 80.5488 39.4851L68.5001 51.5338L62.4515 45.4851C60.4073 43.441 60.4073 40.1268 62.4515 38.0826V38.0826Z" fill="#2DCA73"/>
        </g>
        </g>
        <defs>
        <filter id="filter0_dsucess" x="46.5" y="19.2496" width="49" height="49" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
        <feOffset dy="1.75"/>
        <feGaussianBlur stdDeviation="1.75"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0.133333 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0.219897 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
        </filter>
        <clipPath id="succesnot">
        <rect width="140" height="140" fill="white" transform="translate(0.5 0.00012207)"/>
        </clipPath>
        </defs>
    </svg>

    <svg
      v-else-if="type === 'waypoint-add'"
      :width="width" 
      :height="height" 
      viewBox="0 0 17 17"
    >
      <path d="M2.65685 3.02088C-0.454416 6.13215 -0.454415 11.2233 2.65686 14.3346C5.76813 17.4459 10.8593 17.4459 13.9706 14.3346C17.0818 11.2233 17.0818 6.13215 13.9706 3.02088C10.8593 -0.0903918 5.76812 -0.0903914 2.65685 3.02088ZM12.2735 7.68778L12.2735 9.66768L9.30366 9.66768L9.30366 12.6375L7.32376 12.6375L7.32376 9.66768L4.35391 9.66768L4.35391 7.68778L7.32376 7.68778L7.32376 4.71793L9.30366 4.71793L9.30366 7.68778L12.2735 7.68778Z"/>
    </svg>

    <svg
      v-else-if="type === 'waypoint-close'"
      :width="width" 
      :height="height" 
      viewBox="0 0 16 16"
    >
      <path d="M8 0.5C3.875 0.5 0.5 3.875 0.5 8C0.5 12.125 3.875 15.5 8 15.5C12.125 15.5 15.5 12.125 15.5 8C15.5 3.875 12.125 0.5 8 0.5ZM11.2812 9.96875L9.96875 11.2812L8 9.3125L6.03125 11.2812L4.71875 9.96875L6.6875 8L4.71875 6.03125L6.03125 4.71875L8 6.6875L9.96875 4.71875L11.2812 6.03125L9.3125 8L11.2812 9.96875Z"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
};
</script>

<style lang="scss" scoped>
.svg {
  display: inline-block;

  svg {
    display: block;
  }
}
</style>
